<template>
    <div class="profile__main">
        <div class="profile__main__header">
            <h3 class="profile__main__header__title">
                ویرایش اطلاعات شخصی
            </h3>
            <a :href="route('site.profile', ['edit'])" class="btn custom-btn profile__main__header__btn">
                ویرایش اطلاعات
            </a>
        </div>
        <div class="profile__main__body">
            <div class="profile__main__account" :class="{loading}">
                <div class="profile__main__account__item">
                    <div class="profile__main__account__item__content">
                        <span class="profile__main__account__item__label">نام</span>
                        <span class="profile__main__account__item__value">{{user.first_name ? user.first_name : '-'}}</span>
                    </div>
                    <span class="profile__main__account__item__icon icon-Chevron_left"></span>
                </div>
                <div class="profile__main__account__item">
                    <div class="profile__main__account__item__content">
                        <span class="profile__main__account__item__label">نام خانوادگی</span>
                        <span class="profile__main__account__item__value">{{user.last_name ? user.last_name : '-'}}</span>
                    </div>
                    <span class="profile__main__account__item__icon icon-Chevron_left"></span>
                </div>
                <div class="profile__main__account__item">
                    <div class="profile__main__account__item__content">
                        <span class="profile__main__account__item__label">شماره موبایل</span>
                        <span class="profile__main__account__item__value">{{user.mobile ? user.mobile : '-'}}</span>
                    </div>
                    <span class="profile__main__account__item__icon icon-Chevron_left"></span>
                </div>
                <div class="profile__main__account__item">
                    <div class="profile__main__account__item__content">
                        <span class="profile__main__account__item__label">کدملی</span>
                        <span class="profile__main__account__item__value">{{user.national_code ? user.national_code : '-'}}</span>
                    </div>
                    <span class="profile__main__account__item__icon icon-Chevron_left"></span>
                </div>
                <div class="profile__main__account__item">
                    <div class="profile__main__account__item__content">
                        <span class="profile__main__account__item__label">تاریخ تولید</span>
                        <span class="profile__main__account__item__value">{{user.birth_date ? user.birth_date.split(' ')[0] : '-'}}</span>
                    </div>
                    <span class="profile__main__account__item__icon icon-Chevron_left"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ProfileDashboard",
    data() {
        return {
            loading: false,
            user :{
                first_name: '',
                last_name: '',
                national_code: '',
                birth_date: '',
                mobile: '',
            }
        }
    },
    computed: {
        authenticated() {
            console.log('hi');
            return this.isAuthenticated();
        },
    },
    watch: {
        authenticated() {
            this.checkIsLoading();
        }
    },
    methods: {
        async request() {
            this.loading = true;
            const token = this.token();
            const config = {
                headers: { Authorization: `Bearer ${token}` }
            };
            await this.axios.get(this.route('api.profile.data'), config).then(response => {
                this.user.first_name = response.data.data.first_name;
                this.user.last_name = response.data.data.last_name;
                this.user.national_code = response.data.data.detail?.national_code;
                this.user.birth_date = response.data.data.detail?.birth_date;
                this.user.mobile = response.data.data.mobile;
                this.loading = false;
            });
        },
    },
    mounted() {
        this.request();
    }
}
</script>

<style scoped>

</style>
